import AboutDialog from './AboutDialog.connect';
import AboutDialogSagas from './AboutDialog.sagas';
import AboutDialogConstants from './AboutDialog.constant';

AboutDialog.sagas = AboutDialogSagas;
AboutDialog.constants = AboutDialogConstants;
export default AboutDialog;
